<template>
  <div class="insights-ai-usage-members-widget insights-widget">
    <div class="widget-wrapper">
      <div class="widget-common widget-large widget-full-height">
        <div class="widget-title d-flex align-items-baseline">
          Members
          <i
            v-tooltip="tooltipOptions"
            class="hi hi-info-filled ml-5"
            :title="infoTooltip"
          />
        </div>
        <div
          class="widget-body"
          :class="bodyClasses"
        >
          <template v-if="isReady">
            <InsightsNoData
              v-if="isEmptyWidget"
              :type="emptyReason"
            />
            <div
              v-else
              class="table-responsive"
            >
              <table class="table members-table">
                <thead>
                  <tr>
                    <th>Member</th>
                    <th class="num">Sessions</th>
                    <th class="num">Events</th>
                    <th class="num">Input</th>
                    <th class="num">Output</th>
                    <th class="num">Cache</th>
                    <th class="num">Cache hit</th>
                    <th>Top model</th>
                    <th>Interface</th>
                    <th class="num">Est. cost</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="member in members"
                    :key="member.user_id"
                  >
                    <td>{{ member.name }}</td>
                    <td class="num">{{ member.sessions }}</td>
                    <td class="num">{{ member.events }}</td>
                    <td class="num">{{ number(member.input_total) }}</td>
                    <td class="num">{{ number(member.output_total) }}</td>
                    <td class="num">{{ number(member.cache_total) }}</td>
                    <td class="num">{{ member.cache_pct == null ? '—' : `${member.cache_pct}%` }}</td>
                    <td>{{ member.top_model || '—' }}</td>
                    <td>{{ member.top_interface || '—' }}</td>
                    <td class="num">
                      <b>${{ member.cost_usd.toLocaleString() }}</b>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { INSIGHTS } from '~/app_constants';
import { numericValue } from '~/utils/insights_utils';
import { Insights } from '~/mixins';
import { mapGetters } from 'vuex';

export default {
  name: 'InsightsAiUsageMembersWidget',
  components: {
    InsightsNoData: () => import('~/components/insights/InsightsNoData.vue'),
  },
  mixins: [Insights],
  data: () => ({
    widgetKey: INSIGHTS.api.aiUsage.members,
    tooltipOptions: Object.freeze({ html: true }),
    infoTooltip:
      'AI usage per member, ordered by estimated cost. $ figures are API rate-card equivalents — ' +
      'a usage benchmark for comparing members/tools, not actual subscription spend.',
  }),
  computed: {
    ...mapGetters({ widgetData: 'aiUsageMembers' }),
    members() {
      return this.widgetData?.members || [];
    },
  },
  methods: {
    number(value) {
      return numericValue(value || 0, { maxNumberBeforeSymbol: 9999, roundDigits: 1 });
    },
  },
};
</script>

<style lang="scss">
.insights-ai-usage-members-widget {
  .members-table {
    th,
    td {
      white-space: nowrap;
    }

    th.num,
    td.num {
      text-align: right;
      font-variant-numeric: tabular-nums;
    }
  }
}
</style>
